import React from 'react';
import PropTypes from 'prop-types';
import IconHeader from '../IconHeader/IconHeader';
import FSFlatButton from '../../../src/components/lib/FSFlatButton';
import { openTab } from '../../../src/utils/openTab';

const PageFooterAd = (props) => {
  const containerStyle = {};

  if (props.backgroundImage) {
    containerStyle.backgroundImage = `url(${props.backgroundImage})`;
    containerStyle.backgroundRepeat = 'no-repeat';
    containerStyle.backgroundSize = 'cover';
  }

  return (
    <div className={`page-footer-ad-container ${props.containerClass} row`} style={containerStyle}>
      <div className='content col-xs-12 col-sm-8'>
        <IconHeader
          title={props.title}
          icon={props.icon}
          subtitle={props.subtitle}
        />
      </div>
      <div className='col-xs-12 col-sm-4 col-lg-3'>
        <FSFlatButton
          label={props.buttonTitle}
          href={props.buttonHref}
          style={FSFlatButton.style({ margin: '7px 0 0', display: 'block', width: '100%' })}
          backgroundColor={props.buttonColor || '#FAA718'}
          hoverColor={props.buttonHoverColor || '#81A2CA'}
          onClick={e => openTab(props.buttonHref, e)}
        />
      </div>
    </div>
  );
};

PageFooterAd.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  buttonTitle: PropTypes.string,
  buttonHref: PropTypes.string,
  backgroundImage: PropTypes.string,
  containerClass: PropTypes.string,
  buttonColor: PropTypes.string,
  buttonHoverColor: PropTypes.string,
};
export default PageFooterAd;



// WEBPACK FOOTER //
// ./shared/components/PageFooterAd/PageFooterAd.js